import sendTargetYM from './sendTargetYM.js';
import sendTargetVK from './sendTargetVK';

export default function setMetricsTarget(
    yandexMetrics, vkMetrics, className, goal, containerId
) {
    const container = document.getElementById(containerId);
    if (container) {
        container.addEventListener('click', (event) => {
            if (event.target && event.target.closest(`.${ className }`)) {
                if (yandexMetrics.length) {
                    yandexMetrics.forEach(({ value }) => {
                        sendTargetYM(value, goal);
                    });
                }
                if (vkMetrics.length) {
                    vkMetrics.forEach(({ value }) => {
                        sendTargetVK(value, goal);
                    });
                }
            }
        });
    }
}